export default {
  CUSTOMER_JOB_REQUEST_FORM: 'CUSTOMER_JOB_REQUEST_FORM',
  OFFICE_CREATE_PROJECT: 'OFFICE_CREATE_PROJECT',
  OFFICE_TRAINING_PROJECT: 'OFFICE_TRAINING_PROJECT',
  SUPERMOVE_INTEGRATION_UNIGROUP: 'SUPERMOVE_INTEGRATION_UNIGROUP',
  SUPERMOVE_INTEGRATION_AWS_SES: 'SUPERMOVE_INTEGRATION_AWS_SES',
  SALES_APP_CALL_IMPORT: 'SALES_APP_CALL_IMPORT',
  UNKNOWN: 'UNKNOWN',
};
